import { writeCookie, readCookie } from 'vlab-frontend-components/dist/cjs/utils/auth';

const cookieLanguage = '@VLAB_LANGUAGE';

export const languages = {
    getLanguage: () => {
        const ln = readCookie(cookieLanguage)
        return ln
    },

    setLanguage: (value: string, days: number = 30) => {
        writeCookie(cookieLanguage, value, days);
    }
}